import {
  Typography,
  Box,
  Grid,
  List,
  ListItem,
  Stack,
  Divider,
} from "@mui/material";

const Preview6 = ({
  fieldValues,
  selectedColor,
  fullHeight = false,
  page = "preview",
  sections
}) => {
  let headerFontSize ='30px',subHeaderFontSize ='16px', headerPadding = 5, contentpadding = 3,subContentPadding = 1, titleFontSize = '20px', subTitleFontSize='18px', contentFontSize = '16px';
    if(page === 'template'){
        headerFontSize = '16px'
        subHeaderFontSize = '10px'
        headerPadding = 2
        contentpadding = 1
        subContentPadding = 0.5
        titleFontSize = '12px'
        subTitleFontSize = '10px'
        contentFontSize = '10px'
    }

  const geteducationContent = () =>{
      return <Grid item xs={12} p={subContentPadding}>
      <Typography
        sx={{
          fontSize: titleFontSize,
          fontWeight: 600,
          color: selectedColor?.[0] || "#000",
        }}
      >
        Education
      </Typography>
      <Divider sx={{ borderColor: selectedColor?.[0] || "#000" }} />
      <Stack spacing={1} marginTop={1}>
        {fieldValues.education.map((edu, index) => {
              return (
                <Grid key={index} container sx={12}>
                  <Grid item xs={12}>
                    <Typography sx={{ fontSize: subTitleFontSize }}>
                      {edu.degree} {edu.field_of_study}, {edu.start_date[0]}
                      -{edu.end_date[0]}
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography sx={{ fontSize: contentFontSize }}>
                      {edu.school_name}, {edu.school_location}
                    </Typography>
                  </Grid>
                </Grid>
              );
            })}        
      </Stack>
    </Grid>
  }
  const getexperienceContent = () =>{
    return <Grid item xs={12} p={subContentPadding}>
    <Typography
      sx={{
        fontSize: titleFontSize,
        fontWeight: 600,
        color: selectedColor?.[0] || "#000",
      }}
    >
      Professional Experience
    </Typography>
    <Divider sx={{ borderColor: selectedColor?.[0] || "#000" }} />
    <Stack spacing={1} marginTop={1}>
      {fieldValues.experience.map((exp, index) => {
            return (
              <>
                <Grid key={index} container xs={12}>
                  <Grid item xs={6}>
                    <Typography
                      sx={{
                        fontSize: contentFontSize,
                        fontWeight: "600",
                      }}
                    >
                      {exp.employer}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography
                      sx={{
                        fontSize: contentFontSize,
                        textAlign: "end",
                      }}
                    >
                      {exp.start_date[0]} {exp.start_date[1]}-
                      {exp.end_date[0]} {exp.end_date[1]}
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography sx={{ fontSize: contentFontSize }}>
                      {exp.job_title}
                    </Typography>
                  </Grid>
                </Grid>
                {exp.description ? (
                  <Typography
                    sx={{
                      fontSize: contentFontSize,
                      "& li::marker": {
                        color: selectedColor?.[0] || "#000",
                      },
                      "& ul": {
                        paddingLeft: "18px",
                        margin: "5px 0 0 0",
                      },
                    }}
                    dangerouslySetInnerHTML={{__html: exp.description?._cache?.html ? exp.description?._cache?.html.toString('html') : exp.description.toString('html')}}
                  ></Typography>
                ) : (
                  ""
                )}
              </>
            );
      })}
    </Stack>
  </Grid>
  }
  const getskillsContent = () =>{
    return <Grid item xs={12} p={subContentPadding}>
    <Typography
      sx={{
        fontSize: titleFontSize,
        fontWeight: 600,
        color: selectedColor?.[0] || "#000",
      }}
    >
      Key Skills
    </Typography>
    <Divider sx={{ borderColor: selectedColor?.[0] || "#000" }} />
    <List disablePadding sx={{ listStyleType: "disc", pl: "18px" }}>
     {fieldValues.skills.map((skill, i) => {
            return (
              <ListItem
              key={i}
                sx={{
                  display: "list-item",
                  padding: `${i === 0 ? 5 : 0}px 0px 0px 0px`,
                  "&::marker": {
                    color: selectedColor?.[0] || "#000",
                  },
                }}
              >
                <Typography
                  sx={{ fontSize: contentFontSize, fontWeight: 600 }}
                >
                  {skill.skill}
                </Typography>
              </ListItem>
            );
          })}            
    </List>
  </Grid>
  }
  const getotherContent = () =>{
    return fieldValues.other.map((other, index) => {
      return (
        <Grid key={index} item xs={12} p={subContentPadding}>
          {other.title ? (
            <>
              <Typography
                sx={{
                  fontSize: titleFontSize,
                  fontWeight: 600,
                  color: selectedColor?.[0] || "#000",
                }}
              >
                {other.title}
              </Typography>
              <Divider
                sx={{ borderColor: selectedColor?.[0] || "#000" }}
              />
            </>
          ) : (
            ""
          )}
          {other.content ? (
            <Typography
              sx={{ fontSize: contentFontSize, margin: 0 }}
              dangerouslySetInnerHTML={{__html: other.content?._cache?.html ? other.content?._cache?.html.toString('html') : other.content.toString('html')}}
            ></Typography>
          ) : (
            ""
          )}
        </Grid>
      );
    })
  }

  return (
    <Box
      sx={{
        boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
        flexGrow: 1,
        width: "100%",
        height: fullHeight ? "100%" : "auto",
        fontFamily: "Times New Roman, Times, serif",
        "& .MuiTypography-root": {
          fontFamily: "Times New Roman, Times, serif",
        },
        "& .MuiGrid-root": {
          fontFamily: "Times New Roman, Times, serif",
        },
        "& .MuiListItemText-root": {
          fontFamily: "Times New Roman, Times, serif",
        },
      }}
    >
      <Grid container px={headerPadding} pt={headerPadding} xs={12}>
        <Grid item xs={12}>
          <Typography
            sx={{
              fontSize: headerFontSize,
              fontWeight: "600",
              color: selectedColor?.[0] || "#000",
            }}
          >
            {fieldValues.f_name || "John"} {fieldValues.l_name}
          </Typography>
          <Typography
            sx={{
              fontSize: subHeaderFontSize,
              fontWeight: "600",
              color: "#000",
            }}
          >
            {fieldValues.designation || "Software Engineer"}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Grid container xs={12}>
            <Grid item xs={6}>
              <Typography sx={{ fontSize: subHeaderFontSize, color: "#000" }}>
                {fieldValues.city || "Chennai"},{" "}
                {fieldValues.state || "Tamilnadu"}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography
                textAlign={"end"}
                sx={{ fontSize: subHeaderFontSize, color: "#000" }}
              >
                {fieldValues.email || "xxx@gmail.com"}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Typography sx={{ fontSize: subHeaderFontSize, color: "#000" }}>
            {fieldValues.phone || "9876543210"}
          </Typography>
        </Grid>
        {fieldValues.objective ? <Grid item xs={12} pt={subContentPadding}>
          <Typography
            sx={{ fontSize: contentFontSize, color: "#000", fontWeight: "600" }}
          >
            {fieldValues.objective}
          </Typography>
        </Grid> : ""}
      </Grid>

      <Grid container p={contentpadding} xs={12}>
        {sections?.map((section)=>{
                    if(section === 'Education'){
                        return fieldValues.education.length ? geteducationContent() : ''
                    }else if(section === 'Experience'){
                        return fieldValues.experience.length ? getexperienceContent() : ''
                    }else if(section === 'Skills'){
                        return fieldValues.skills.length ? getskillsContent() : ''
                    }else if(section === 'Other'){
                        return fieldValues.other.length && fieldValues.other[0].title ? getotherContent() : ''
                    }
                    return ''
                })
            }
      </Grid>
    </Box>
  );
};

export default Preview6;
